import { IPlanKey } from '../types';

export const DEFAULT_USAGE_FEE_PLAN_KEY = IPlanKey.FUNNEL_OPT;
export const DEFAULT_PLAN_KEY_SHOW_USAGE_FEE = IPlanKey.FUNNEL_OPT;
